import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const ScrollGrid = ({ fadeVariant = 'fade-center' }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });

  // Grid draws in as user scrolls into view, reaches full at 0.5, stays
  const gridOpacity = useTransform(scrollYProgress, [0, 0.25, 0.75, 1], [0, 1, 1, 0]);
  const gridScale = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0.92, 1, 1, 0.92]);

  // Masks per variant
  const maskMap = {
    'fade-top': 'linear-gradient(to bottom, black 0%, transparent 60%)',
    'fade-bottom': 'linear-gradient(to top, black 0%, transparent 60%)',
    'fade-center': 'radial-gradient(ellipse 70% 50% at 50% 50%, black 0%, transparent 70%)',
    'fade-top-right': 'radial-gradient(ellipse 70% 70% at 75% 25%, black 0%, transparent 70%)',
    'fade-bottom-left': 'radial-gradient(ellipse 70% 70% at 25% 75%, black 0%, transparent 70%)',
    'fade-left': 'linear-gradient(to right, black 0%, transparent 60%)',
    'fade-right': 'linear-gradient(to left, black 0%, transparent 60%)',
  };

  const glowMap = {
    'fade-top': 'radial-gradient(ellipse 60% 40% at 50% 0%, rgba(124, 106, 239, 0.07) 0%, transparent 70%)',
    'fade-bottom': 'radial-gradient(ellipse 60% 40% at 50% 100%, rgba(124, 106, 239, 0.07) 0%, transparent 70%)',
    'fade-center': 'radial-gradient(ellipse 50% 40% at 50% 50%, rgba(124, 106, 239, 0.06) 0%, transparent 70%)',
    'fade-top-right': 'radial-gradient(ellipse 50% 50% at 80% 15%, rgba(124, 106, 239, 0.08) 0%, transparent 70%)',
    'fade-bottom-left': 'radial-gradient(ellipse 50% 50% at 20% 85%, rgba(155, 106, 239, 0.08) 0%, transparent 70%)',
    'fade-left': 'radial-gradient(ellipse 40% 50% at 0% 50%, rgba(100, 80, 220, 0.08) 0%, transparent 70%)',
    'fade-right': 'radial-gradient(ellipse 40% 50% at 100% 50%, rgba(140, 100, 255, 0.08) 0%, transparent 70%)',
  };

  const maskStyle = maskMap[fadeVariant] || maskMap['fade-center'];
  const glowStyle = glowMap[fadeVariant] || glowMap['fade-center'];

  return (
    <div
      ref={ref}
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      {/* Animated grid lines */}
      <motion.div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage:
            'linear-gradient(rgba(124, 106, 239, 0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(124, 106, 239, 0.06) 1px, transparent 1px)',
          backgroundSize: '50px 50px',
          maskImage: maskStyle,
          WebkitMaskImage: maskStyle,
          opacity: gridOpacity,
          scale: gridScale,
        }}
      />
      {/* Gradient glow touch */}
      <motion.div
        style={{
          position: 'absolute',
          inset: 0,
          background: glowStyle,
          pointerEvents: 'none',
          opacity: gridOpacity,
        }}
      />
    </div>
  );
};

export default ScrollGrid;
